import { create } from "zustand";
import { devtools } from "zustand/middleware";

import { createSystemPortalConfigSlice } from "./slice/system";
import { createLicenseSlice } from "./slice/license";
import { createDashboardSlice } from "./slice/dashboard";
import { createUnsavedChangesBlockerSlice } from './slice/unsavedChangesBlocker';

import { getServerEnvironment } from "utils/serverUrl";

const serverEnvironment = getServerEnvironment();
const isDev = serverEnvironment.environment === "rd" || serverEnvironment.environment === "qa"

const storeCreator = (set, get, api) => ({
  ...createSystemPortalConfigSlice(set, get, api),
  ...createLicenseSlice(set, get, api),
  ...createDashboardSlice(set, get, api),
  ...createUnsavedChangesBlockerSlice(set, get, api),
});

const useZustandStore = create(
  isDev ? devtools(storeCreator, { name: "rootZustandStore" }) : storeCreator
);

export default useZustandStore